define('modules/uv-shared-module/Bookmark',["require", "exports"], function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var Bookmark = /** @class */ (function () {
        function Bookmark() {
        }
        return Bookmark;
    }());
    exports.Bookmark = Bookmark;
});
//# sourceMappingURL=Bookmark.js.map
